import axios from "axios";

const axiosObject = axios.create();

function getMapLatitudeLongitude(
  location: string
): Promise<{ latitude: string; longitude: string }> {
  return new Promise((resolve, reject) => {
    const uri = `https://nominatim.openstreetmap.org/search?q=${encodeURIComponent(
      location
    )}&format=json&limit=1`;

    axiosObject
      .get(uri)
      .then((response) => {
        if (response.data.length > 0) {
          const locationData = response.data[0];
          if (locationData?.lat && locationData?.lon) {
            resolve({
              latitude: locationData.lat,
              longitude: locationData.lon,
            });
          } else {
            reject("Location data is temporarily unavailable.");
          }
        } else {
          reject("Location data is temporarily unavailable.");
        }
      })
      .catch((error) => {
        reject(`Error fetching location: ${error.message}`);
      });
  });
}

export { getMapLatitudeLongitude };
